import type { GetLeadsStatResponseData } from "@/app/(authenticated)/leads/_modules/types/search-lead-types";

export const LEAD_STATUS_CONFIG = [
  {
    apiKey: "New lead" as keyof GetLeadsStatResponseData["leadsByStatus"],
    label: "Leads",
    color: "bg-blue-100 text-blue-800",
    description: "Recently added leads that haven't been contacted yet",
  },
  {
    apiKey: "Appt" as keyof GetLeadsStatResponseData["leadsByStatus"],
    label: "Appointments",
    color: "bg-cyan-600 text-cyan-100",
    description: "Leads with scheduled appointments",
  },
  {
    apiKey: "Underwriting" as keyof GetLeadsStatResponseData["leadsByStatus"],
    label: "Underwriting",
    color: "bg-amber-500 text-amber-100",
    description: "Leads currently being processed for approval",
  },
  {
    apiKey: "Sold & Approved" as keyof GetLeadsStatResponseData["leadsByStatus"],
    label: "Approved",
    color: "bg-green-100 text-green-800",
    description: "Successfully converted leads",
  },
  {
    apiKey: "Bad number" as keyof GetLeadsStatResponseData["leadsByStatus"],
    label: "Bad Number",
    color: "bg-red-100 text-red-800",
    description: "Leads with invalid or unreachable phone numbers",
  },
  {
    apiKey: "No sale" as keyof GetLeadsStatResponseData["leadsByStatus"],
    label: "No Sale",
    color: "bg-red-100 text-red-800",
    description: "Leads that were contacted but did not convert",
  },
  {
    apiKey: "Do not call" as keyof GetLeadsStatResponseData["leadsByStatus"],
    label: "Do Not Call",
    color: "bg-amber-800 text-amber-100",
    description: "Leads that have requested not to be contacted",
  },
  {
    apiKey: "Declined" as keyof GetLeadsStatResponseData["leadsByStatus"],
    label: "Declined",
    color: "bg-gray-600 text-gray-100",
    description: "Leads that were declined during underwriting",
  },
  {
    apiKey: "Lapsed" as keyof GetLeadsStatResponseData["leadsByStatus"],
    label: "Lapsed",
    color: "bg-black text-white",
    description: "Leads whose policies have lapsed",
  },
] as const;
